import { Component, Input, OnInit } from '@angular/core';
import { ApiError } from 'app/interfaces/error.interface';
import { NotificationsService } from 'app/services/notifications.service';
import { ICoeNote } from 'modules/contacts/interfaces/coe-notes.interface';
import { CoeNotesService } from 'modules/contacts/services/coe-notes.service/coe-notes.service';
import { IContact } from 'shared/interfaces/contact.interface';

@Component({
	selector: 'contact-notes',
	templateUrl: './contact-notes.component.html',
	styleUrls: ['./contact-notes.component.scss'],
})
export class ContactNotes implements OnInit {
	loading = true;
	loadingMore = false;
	pageSize = {
		default: 8,
		actual: 8,
	};
	coeNotes = {
		items: [],
		total: 0,
	};

	@Input() contact: IContact | null;

	constructor(
		private coeNotesService: CoeNotesService,
		private notificationsService: NotificationsService
	) {}

	ngOnInit(): void {
		this.fetchCoeNotes();
	}

	loadMore() {
		this.loadingMore = true;
		this.pageSize.actual = this.pageSize.actual + this.pageSize.default;

		this.fetchCoeNotes(this.pageSize.actual);
	}

	fetchCoeNotes(pageSize?: number) {
		const limit = pageSize || this.pageSize.default;

		this.coeNotesService
			.getNotes(this.contact.refUserId, limit.toString())
			.subscribe(
				(result) => {
					this.coeNotes = result;
					this.loading = false;
					this.loadingMore = false;
				},
				(error) => {
					this.notificationsService.showError(
						(error.error as ApiError).messageI18n
					);
				}
			);
	}

	toggleCardView(item: ICoeNote): void {
		item.expanded = item.expanded ? false : true;
	}
}
